import { _ } from "libs";

export const INVALID_RESERVATION = "0_006_00001";
export const INVALID_COURT = "0_006_00002";
export const INVALID_DATE = "0_006_00003";
export const INVALID_TIME = "0_006_00004";
export const INVALID_DURATION = "0_006_00005";
export const INVALID_DURATION_NEED_PARTNERS = "0_006_00040";
export const INVALID_PROFILE_NEED_MORE_INFO = "0_006_00041";
export const GLOBAL_VERIFICATION = "0_006_00006";
export const STRIPE_ERROR = "0_006_00007";
export const OWNER_INVALID_MEMBERSHIP = "0_006_00008";
export const COURT_DOES_NOT_HAVE_BALLMACHINE = "0_006_00009";
export const ONLY_WITH_POSITIVE_FINANCE = "0_006_00010";
export const BOOKING_FORBIDDEN = "0_006_00011";
export const GUEST_NOT_ALLOWED = "0_006_00012";
export const OFF_LIMITS_RESERVATION_WITH_GUEST = "0_006_00013";
export const MISSING_PLAYERS = "0_006_00014";
export const PARTNER_NAME_REQUIRED = "0_006_00015";
export const FORBIDDEN_CANCELLATION = "0_006_00016";
export const RESERVATION_IN_PAST_NOT_ALLOWED = "0_006_00017";
export const PLAYER_ALREADY_IN_RESERVATION = "0_006_00018";
export const PARTNER_INVALID_MEMBERSHIP = "0_006_00019";
export const TOO_MANY_ACTIVE_RESERVATIONS_ON_ONE_DAY = "0_006_00020";
export const TOO_MANY_ACTIVE_RESERVATIONS = "0_006_00021";
export const EMAIL_NOT_VALID = "0_006_00022";
export const RESERVATION_COLLIDES_WITH_ANOTHER_RESERVATION = "0_006_00023";
export const CARD_INVALID_EXPIRY_MONTH = "0_006_00024";
export const CARD_INCORRECT_NUMBER = "0_006_00025";
export const CARD_INVALID_CVC = "0_006_00026";
export const CARD_INVALID_NUMBER = "0_006_00027";
export const CARD_INVALID_EXPIRY_YEAR = "0_006_00028";
export const CARD_EXPIRED = "0_006_00029";
export const CARD_INCORRECT_CVC = "0_006_00030";
export const CARD_DECLINED = "0_006_00031";
export const CARD_MISSING = "0_006_00032";
export const CARD_PROCESSING_ERROR = "0_006_00033";
export const CARD_RATE_LIMIT = "0_006_00034";
export const RESERVATION_COLLIDES_WITH_BLOCKING = "0_006_00035";
export const RESERVATION_INVALID_PERMISSIONS = "0_006_00036";
export const RESERVATION_PLAYER_IS_NOT_OWNER = "0_006_00037";
export const CARD_UNDEFINED = "0_006_00038";
export const CLUB_UNDEFINED = "0_006_0039";
export const PAYMENT_SCA = "0_004_12000";
export const PAYMENT_CARD_EXPIRED = "0_004_11008";

const errorMap = {
	[INVALID_RESERVATION]: "error.invalidReservation",
	[INVALID_COURT]: "error.invalidCourt",
	[INVALID_DATE]: "error.invalidDate",
	[INVALID_TIME]: "error.invalidTime",
	[INVALID_DURATION]: "error.invalidDuration",
	[INVALID_DURATION_NEED_PARTNERS]: "error.invalidDurationNeedPartners",
	[INVALID_PROFILE_NEED_MORE_INFO]: "error.clubNeedsFullContactDetails",
	[GLOBAL_VERIFICATION]: "error.globalVerification",
	[STRIPE_ERROR]: "error.stripeError",
	[OWNER_INVALID_MEMBERSHIP]: "error.ownerInvalidMembership",
	[COURT_DOES_NOT_HAVE_BALLMACHINE]: "error.courtDoesNotHaveBallmachine",
	[ONLY_WITH_POSITIVE_FINANCE]: "error.onlyWithPositiveFinance",
	[BOOKING_FORBIDDEN]: "error.bookingForbidden",
	[GUEST_NOT_ALLOWED]: "error.guestNotAllowed",
	[OFF_LIMITS_RESERVATION_WITH_GUEST]: "error.offLimitsReservationWithGuest",
	[MISSING_PLAYERS]: "error.missingPlayers",
	[PARTNER_NAME_REQUIRED]: "error.partnerNameRequired",
	[FORBIDDEN_CANCELLATION]: "error.forbiddenCancellation",
	[RESERVATION_IN_PAST_NOT_ALLOWED]: "error.reservationInPastNotAllowed",
	[PLAYER_ALREADY_IN_RESERVATION]: "error.playerAlreadyInReservation",
	[PARTNER_INVALID_MEMBERSHIP]: "error.partnerInvalidMembership",
	[TOO_MANY_ACTIVE_RESERVATIONS_ON_ONE_DAY]: "error.tooManyActiveReservationsOnOneDay",
	[TOO_MANY_ACTIVE_RESERVATIONS]: "error.tooManyActiveReservations",
	[EMAIL_NOT_VALID]: "error.emailNotValid",
	[RESERVATION_COLLIDES_WITH_ANOTHER_RESERVATION]: "error.reservationCollidesWithAnotherReservation",
	[CARD_INVALID_EXPIRY_MONTH]: "error.cardInvalidExpiryMonth",
	[CARD_INCORRECT_NUMBER]: "error.cardIncorrectNumber",
	[CARD_INVALID_CVC]: "error.cardInvalidCVC",
	[CARD_INVALID_NUMBER]: "error.invalidNumber",
	[CARD_INVALID_EXPIRY_YEAR]: "error.cardInvalidExpiryYear",
	[CARD_EXPIRED]: "error.cardExpired",
	[PAYMENT_CARD_EXPIRED]: "error.cardExpired",
	[CARD_INCORRECT_CVC]: "error.cardIncorrectCVC",
	[CARD_DECLINED]: "error.cardDeclined",
	[CARD_MISSING]: "error.cardMissing",
	[CARD_PROCESSING_ERROR]: "error.cardProcessingError",
	[CARD_RATE_LIMIT]: "error.cardRateLimit",
	[RESERVATION_COLLIDES_WITH_BLOCKING]: "error.reservationCollidesWithBlocking",
	[RESERVATION_INVALID_PERMISSIONS]: "error.reservationInvalidPermissions",
	[RESERVATION_PLAYER_IS_NOT_OWNER]: "error.reservationPlayerIsNotOwner",
	[CARD_UNDEFINED]: "error.cardUndefined",
	[CLUB_UNDEFINED]: "error.clubUndefined",
	[PAYMENT_SCA]: "error.paymentAuthenticationRequired",
};

export function getBookingError(code: string): string {
	if (errorMap.hasOwnProperty(code)) {
		return _(errorMap[code]);
	}

	return _(code);
}
